import { defineStore } from 'pinia'
import { User } from '../pages/users/types'
import { getUserProfile, signupUser } from '../data/pages/users'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: 'Vasili Savitski',
      username: '',
      email: 'vasili@gmail.com',
      memberSince: '8/12/2020',
      pfp: 'https://picsum.photos/id/22/200/300',
      tenantKey: '',
      is2FAEnabled: false,
      role: '',
      accountId: '',
      currentUser: null as User | null,
      mode: (localStorage.getItem('spread-user-mode') ?? 'fan') as 'fan' | 'organiser',
      organiserHintSeen: localStorage.getItem('spread-organiser-hint-seen') === 'true',
    }
  },

  actions: {
    setMode(mode: 'fan' | 'organiser') {
      this.mode = mode
      localStorage.setItem('spread-user-mode', mode)
      if (mode === 'organiser') {
        this.organiserHintSeen = true
        localStorage.setItem('spread-organiser-hint-seen', 'true')
      }
    },

    dismissOrganiserHint() {
      this.organiserHintSeen = true
      localStorage.setItem('spread-organiser-hint-seen', 'true')
    },

    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },
    setAccountId(id: string) {
      this.accountId = id
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    async signup(user: User) {
      const newUser = await signupUser(user)
      return newUser
    },

    async retrieveUserinfo() {
      const currentUser = await getUserProfile()
      if (!currentUser) {
        this.currentUser = null
        return
      } else {
        this.currentUser = currentUser
      }
      this.userName = currentUser.fullname
      this.username = currentUser.username || ''
      this.email = currentUser.email || ''
      this.pfp = currentUser.avatar || ''
      this.memberSince = currentUser.created_at
      this.tenantKey = currentUser.tenantKey
      this.role = currentUser.role
    },
  },
})
